/**
 * @fileoverview GET handler for the "/apps/api_request_log/requests" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiRequestLogRequests } from "./constants";
import type { AppsApiRequestLogRequestsParams, AppsApiRequestLogRequestsResult } from "./types";

export const getDataTableAppsApiRequestLogRequests = reactQueryTableFetcherAdapter(
  appsApiRequestLogRequests,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      limit,
      start = 0,
      startTimeEpochSeconds,
      endTimeEpochSeconds,
    }: AppsApiRequestLogRequestsParams
  ): Promise<AppsApiRequestLogRequestsResult> => {
    return fetch(
      "/apps/api_request_log/requests",
      "GET",
      {
        limit,
        start,
        start_time_epoch_seconds: startTimeEpochSeconds,
        end_time_epoch_seconds: endTimeEpochSeconds,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
